import React, { useState ,useEffect} from "react";
import Style from '../Styles/Common.module.css';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { Link } from "react-router-dom";
import { IoArrowForwardCircleOutline } from "react-icons/io5";
import {getAlumnisAllata} from '../../services/routes.services'
import constants from '../../services/constants'
import PlaceholderImage from '../../assest/images/list-img01.png';  // Add a placeholder image


const MembersComponent = ()=>{
    const [alumnidata, setAlumniData] = useState([]);
    useEffect(() => {
        getAlumnisAllata()
            .then((res) => {
                const alumni = res.data.latestAlumni;
                setAlumniData(alumni);
                
            })
            .catch((error) => {
                console.log(error);
            });
        },[])
        const lastFourAlumnis = alumnidata &&  alumnidata.length > 0 ? alumnidata.slice(-4) : [];
   
    return(
        <div className={Style.mamberSec}>
            <Container>
                <Row>
                    <Col>
                        <div className={Style.whiteBg}>
                            <Row>
                                <Col>
                                    <div className={Style.sectionTitle}>
                                        <h2>New Members</h2>
                                    </div>
                                </Col>
                            </Row>
                            <Row>
                                {lastFourAlumnis!=''?(
                                    lastFourAlumnis.map((memeber)=>(
                                        <Col key={memeber._id} className={Style.tabWidth}>
                                    <div className={Style.memberElement}>
                                        <div className={Style.memberImg}>
                                           
                                            {/* {memeber.image.indexOf("uploads") > -1 ? ( <img src={memeber.image!=='null' ? `${constants.IMAGE_BASE_URL}user/${memeber.image}` : PlaceholderImage} alt={memeber.name}/>): */}
                                                   <img src={memeber.image!=='null' ? `${constants.IMAGE_BASE_URL}user/${memeber.image}` : PlaceholderImage} alt={memeber.name}/>
                                           
                                        </div>
                                        <div className={Style.memberDetail}>
                                            <h3>{memeber.name} {memeber.last}</h3>
                                            <p>Batch {memeber.batch}</p>
                                        </div>
                                    </div>
                                </Col>
                                    ))
                                ):null}
                              
                            </Row>
                            <Row>
                                <Col>
                                    <div className={Style.directoryLink}>
                                        <Link to='/alumni-directory'>Alumni Directory <IoArrowForwardCircleOutline className={Style.moveIcon} /></Link>
                                    </div>
                                </Col>
                            </Row>
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    )
}

export default MembersComponent;